import axios from 'axios';
import {
  GET_USER_BY_PHONE_URL,
  RESET_PHONE_NUMBER_URL,
} from 'api/resetPhone/constant';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';

export async function getUserByPhoneNumber(param) {
  const config = {
    params: param,
  };
  try {
    return await axios.get(`${GET_USER_BY_PHONE_URL}`, config);
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export function performResetPhoneNumber(payload) {
  try {
    return axios.patch(`${RESET_PHONE_NUMBER_URL}`, payload).then(response => {
      return Promise.resolve(response);
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}
